import classNames from "classnames";
import { profileShape } from "lib/propTypes";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
    profile: state.profile,
});

class CandidateProfileCard extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        profile: profileShape.isRequired,
    };

    static defaultProps = {
        className: null,
    };

    renderStat(name, stat) {
        return (
            <figure className="profile-card__stat">
                <span>{stat || "-"}</span>
                <figcaption>{name}</figcaption>
            </figure>
        );
    }

    render() {
        const { className } = this.props;
        const { user, completeness } = this.props.profile;

        return (
            <div className={classNames("profile-card", className)}>
                <div className="profile-card__icon">
                    <div className="profile-card__initials">
                        <span>{user.initials}</span>
                    </div>
                </div>
                <div className="profile-card__user">
                    <h1 className="profile-card__name fs-hide">{user.full_name}</h1>
                    <div className="profile-card__location fs-hide">{user.city}</div>
                </div>
                <div className="profile-card__stats">
                    {this.renderStat("Total Exp", completeness.experienceYears)}
                    {this.renderStat("Jobs Listed", completeness.jobCount)}
                    {this.renderStat("Detail", completeness.detailLevel)}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(CandidateProfileCard);
